import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';

import { importStatic } from 'utils';

import classes from './ZpChip.module.css';

const propTypes = {
  display: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  enable: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['default', 'white', 'outlined', 'alt']),
  containerClasses: PropTypes.string,
  dataTestId: PropTypes.string,
  hideCloseIcon: PropTypes.bool,
  showTextAsEllipsis: PropTypes.bool,
};

const defaultProps = {
  enable: false,
  theme: 'default',
  hideCloseIcon: false,
  showTextAsEllipsis: true,
};

const ZpChip = (props) => {
  const {
    display,
    enable,
    onClick,
    theme,
    containerClasses,
    dataTestId,
    hideCloseIcon,
    showTextAsEllipsis,
  } = props;
  return (
    <div data-testid={dataTestId} className={classNames('zp-chip', classes.zpChip)}>
      <div
        className={classNames('zp-chip-container noSelect', containerClasses, {
          ['zp-chip-enable']: enable & (theme !== 'alt'),
          [classes.altEnable]: enable & (theme === 'alt'),
          [classes.whiteChip]: theme === 'white',
          [classes.outlined]: !enable && theme === 'outlined',
          [classes.outlinedEnabled]: enable & (theme === 'outlined'),
          [classes.alt]: theme === 'alt',
          [classes.hideCloseIcon]: hideCloseIcon,
          [classes.fullWidth]: !showTextAsEllipsis,
        })}
        onClick={onClick}
        onKeyDown={(e) => [' ', 'Enter'].includes(e.key) && onClick(e)}
        tabIndex={0}
      >
        {typeof display === 'string' ? (
          <span
            className={classNames('zp-chip-display', { [classes.noEllipsis]: !showTextAsEllipsis })}
          >
            {display}
          </span>
        ) : (
          display
        )}
        {!hideCloseIcon && (
          <img src={importStatic('/ui-router/images/select-x.svg')} className="zp-chip-x" />
        )}
      </div>
    </div>
  );
};

ZpChip.propTypes = propTypes;
ZpChip.defaultProps = defaultProps;

export default ZpChip;
